import { type ExtractAsinFn } from "../modules/query_funnel/types";

export const extractAsin: ExtractAsinFn = (string: string): string | null => {
  const asinRegex = /b0[a-z0-9]{8}/i;

  const matches = string.match(asinRegex);
  return matches?.length ? matches[0] : null;
};
